module.exports = __webpack_public_path__ + "img/pesaj-2016.4ae44c04.jpg";